const decode = (value) => decodeURIComponent(value.replace(/\+/g, " "));

export default decode;
